export default __webpack_public_path__ + "static/media/RIDE5.d7706451.mp4";